import {
    leftCableLengthIdsNew,
    leftCableLengthIdsOld,
} from '../components/common/constants';

export const resetLeftCable = (lIds: number[]) => {
    if (lIds) {
        lIds.forEach((id) => {
            if (Object.values(leftCableLengthIdsNew).indexOf(id) >= 0) {
                const indexToSplice = lIds.indexOf(id);
                lIds.splice(indexToSplice, 1);
                const key = getKeyByValue(leftCableLengthIdsNew, id);
                if (key) {
                    if (key in leftCableLengthIdsOld) {
                        const index = Object.keys(
                            leftCableLengthIdsOld
                        ).indexOf(key);
                        const val = Object.values(leftCableLengthIdsOld)[index];
                        lIds.splice(indexToSplice, 0, val);
                    }
                }
            }
        });
    }
    return lIds;
};

function getKeyByValue(object: Record<string, number>, value: number) {
    return Object.keys(object).find((key) => object[key] === value);
}
